/// <amd-module name="Wit/Settings/BoardsExternalIntegration/components/panels/Panel.enum" />
export enum Panel {
    NewConnection,
    Pat,
    AddRepo,
    AddRepoManually,
    ManageRepo,
    Loading,
    EnterpriseAuthenticationMethod,
    EnterpriseCredentials,
    EnterpriseOAuth,
    EnterprisePat,
    RemoveRepo,
    OrgSelection
}
